export const toolDims = 48;
export const maxTools = 8;
export const minTools = 1;

export const minToolboxHeight = toolDims * (minTools + 2);
export const toolboxVerticalMargin = 62;
export const toolboxHorizontalMargin = 15;
